module.exports = __webpack_public_path__ + "img/SAS_MetalHeaterShield.5b8e5734.png";